import React from 'react';
import { Modal, View, StyleSheet } from 'react-native';
import CustomEditorEmptyModal from './CustomEditorEmptyModal';

interface FullscreenCustomEditorModalProps {
  visible: boolean;
  onClose: () => void;
}

const FullscreenCustomEditorModal: React.FC<FullscreenCustomEditorModalProps> = ({ visible, onClose }) => {
  return (
    <Modal visible={visible} animationType="slide" transparent={false}>
      <View style={styles.container}>
        <CustomEditorEmptyModal />
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    width: '100%',
    height: '100%',
  },
});

export default FullscreenCustomEditorModal;
